"use strict";
// This file is created to avoid process.env type being string | null by default
// This script should never throw an error however, as null catch for env is 
// done via webpack.config.js file at envPlugin variable definition
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
// ref: https://dev.to/austinshelby/you-are-reading-environment-variables-the-wrong-way-in-nextjs-45da
var getEnvironmentVariable = function (environmentVariable) {
    var unvalidatedEnvironmentVariable = process.env[environmentVariable];
    if (!unvalidatedEnvironmentVariable) {
        throw new Error("Couldn't find environment variable: ".concat(environmentVariable));
    }
    else {
        return unvalidatedEnvironmentVariable;
    }
};
exports.config = {
    shopifyDomain: getEnvironmentVariable('SHOPIFY_DOMAIN'),
    shopifyPublicStorefrontEndpoint: getEnvironmentVariable('SHOPIFY_PUBLIC_STOREFRONT_ENDPOINT'),
    shopifyPublicStorefrontApiToken: getEnvironmentVariable('SHOPIFY_PUBLIC_STOREFRONT_API_TOKEN'),
    shopifyPublicStorefrontApiVersion: getEnvironmentVariable('SHOPIFY_PUBLIC_STOREFRONT_API_VERSION'),
};
